import { atom, useRecoilValue } from 'recoil';
import { v1 } from "uuid";


export const debateCleanModeState = atom<any>({
    key: `debateCleanModeState/${v1()}`, // 고유한 키
    default: false, // 기본값
});
export const useDebateCleanMode = () => {
    const state = useRecoilValue(debateCleanModeState);
    return state;
}